import { Injectable } from '@angular/core';
import { IntroCard } from './intro-card.model';
import { introCards } from './intro-cards.logic';

/**
 * Fuente de verdad de las tarjetas del Intro (deck SUIT INPROVIDER, lámina 4
 * "Módulos / accesos rápidos").
 *
 * Responsabilidad única (SRP): entregar las `IntroCard[]` del deck. No filtra
 * por permisos ni por flags del tenant —el Intro es el mapa del producto, igual
 * que el sidebar de la suite—; el gate real de navegación vive en los guards de
 * ruta. Separarlo del componente permite sustituir la fuente sin tocar la vista
 * (DIP) y probar el mapeo sin navegador.
 *
 * Los iconos usan Font Awesome (glyphs sólidos que se colorean en blanco sobre
 * el círculo turquesa); los SVG de la fuente `inp-icon` son imágenes oscuras
 * para fondo claro y no rinden bien dentro del círculo.
 */
@Injectable({ providedIn: 'root' })
export class IntroCardsProvider {
  /** Las tarjetas del deck, en el orden de la lámina 4. */
  getCards(): IntroCard[] {
    return introCards();
  }
}
